import { useShallowEffect } from "@mantine/hooks"
import CustomSwitch from "components/Atoms/CustomSwitch"
import StaticMultiSelector from "components/Atoms/StaticMultiSelector"
import SearchFilter, {
  SearchFilterCallout,
} from "components/Organisms/SearchFilter"
import useAuth from "hooks/useAuth"
import { isEmpty } from "lodash-es"
import React from "react"
import { useCurrentDcId } from "store/auth.redux"
import { useFilter } from "store/search-filter/search-filter.reducer"

const StockManagementFilter = () => {
  const [filter, setFilter] = useFilter("ecommerce")
  const { distributionCentres } = useAuth()
  const dcId = useCurrentDcId()
  useShallowEffect(() => {
    if (isEmpty(filter)) {
      setFilter({
        distributionCentreIds: distributionCentres?.filter(
          dc => dc.id === dcId
        ),
      })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter])
  return (
    <SearchFilter
      value={filter}
      getValues={values => {
        setFilter(values)
      }}
      onClear={() => setFilter({})}
      className="ml-3"
    >
      <SearchFilterCallout title="Distribution Centres">
        <StaticMultiSelector
          formClassName="mb-0 ecom-dc-filter"
          fill
          path="distributionCentreIds"
          items={distributionCentres}
        />
      </SearchFilterCallout>

      <SearchFilterCallout title="Stock Status">
        <CustomSwitch className="mt-3" path="isLive" label="Is Live" />
      </SearchFilterCallout>
    </SearchFilter>
  )
}

export default StockManagementFilter
